/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import{defineExtension as e}from"lexical";const r=e({name:"@lexical/react/ReactProvider"});export{r as ReactProviderExtension};
